import {computed, ref} from 'vue';
import {defineStore, storeToRefs} from 'pinia';
import {useProfileStore} from '~/store/profileStore';
import {useSkillSetStore} from '~/store/skill-set/skillSetStore';

function djb2Hash(str: string): string {
    let h = 5381;
    for (let i = 0; i < str.length; i++) {
        h = (Math.imul(h, 31) + str.charCodeAt(i)) | 0;
    }
    return (h >>> 0).toString(36);
}

export const useBrandedVisualStore = defineStore('share-profile-branded-visual', () => {
    const {profile} = storeToRefs(useProfileStore());
    const {profileTopSkills} = storeToRefs(useSkillSetStore());

    const hash = computed(() => {
        const name = profile.value?.firstname ?? '';
        const jobTitle = profile.value?.headline ?? '';
        const fullName = `${profile.value?.firstname ?? ''} ${profile.value?.lastname ?? ''}`;
        const avatarUrl = profile.value?.photo?.baseUrl ? `${profile.value?.photo?.baseUrl}/${profile.value?.photo?.name}` : '';
        const tags = profileTopSkills.value
            .slice(0, 5)
            .map((s) => s.label)
            .join(',');
        const badge = profile.value?.badge ?? '';
        return djb2Hash([name, jobTitle, fullName, avatarUrl, tags, badge].join('|'));
    });

    return {
        hash,
    };
});
